import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(6),
    },
  },

  imgContainer: {
    position: 'relative',
    marginBottom: theme.spacing(6),
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '100%',
    height: `${typeof window !== 'undefined' ? window.innerWidth - 64 : 0}px`,
    position: 'relative',
    zIndex: 1,
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.shadows[0],
    border: `1px solid ${theme.palette.background.lightOverlay}`,
    [theme.breakpoints.up('sm')]: {
      height: 500,
      width: 500,
    },
  },
  imageShadow: {
    height: '90%',
    width: '100%',
    position: 'absolute',
    top: '25%',
    left: '30%',
    zIndex: 0,
    background: theme.palette.extras.strongTeal,
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.shadows[6],
    [theme.breakpoints.up('sm')]: {
      top: '15%',
      left: '30%',
    },
    [theme.breakpoints.up('md')]: {
      height: 500,
      width: 500,
    },
  },

  infoWrapper: {
    justifyContent: 'space-between',
    padding: theme.spacing(1),
  },

  infoClass: {
    flexShrink: 1,
    flexGrow: 0,
    '& span': {
      fontSize: theme.typography.caption.fontSize,
      fontWeight: theme.typography.fontWeightLight,
      color: theme.palette.text.disabled,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
  },

  content: {
    padding: theme.spacing(4, 0),
    color: theme.palette.text.main,
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8, 0),
    },
  },
}))
